const component = {
  template: `
    <div class="floatingTabs">
      <div class="floatingTabs__container">
        <div class="floatingTab" ng-repeat="tab in $ctrl.tab">
          <a href="{{tab.link}}">{{tab.title}}</a>
        </div>
      </div>
    </div>
  `,
  bindings: {
    id: '@',
    tabs: '@',
  },
  controller() {
    this.$onInit = () => {
      this.tab = JSON.parse(decodeURIComponent(this.tabs));
    };
  },
};

export default component;



// WEBPACK FOOTER //
// ./js/containers/causePortal/components/floatingTabs/index.js